<template>
    <div class="col-lg-12 mt-3">
        <div class="row">
            <div class="col-lg-12 d-flex justify-content-end">
                <button v-show="ObjSolicitudAlmacen.IdSolicitudAlmacen==0 || (pOrigen=='SolicitudExtra')" @click="AbrirModal" class="btn btn-primary">Agregar Insumo</button>
            </div>
            <div class="col-lg-12">
                <div class="table-responsive">
                    <table class="table align-items-center mb-0">
                        <thead>
                            <tr>
                                <th v-if="ObjSolicitudAlmacen.IdSolicitudAlmacen==0 || pOrigen=='SolicitudExtra'"></th>
                                <th>Nombre</th>
                                <th>Stock</th>
                                <th>Cantidad de Salida</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,index) in ObjSolicitudAlmacen.Insumos" :key="index">
                                <td v-if="ObjSolicitudAlmacen.IdSolicitudAlmacen==0 || pOrigen=='SolicitudExtra'"><button @click="EliminarInsumo(item.IdMaterial)" class="btn btn-danger"><i class="fa fa-trash"></i></button></td>
                                <td style="width:70%">{{ item.Nombre }}</td>
                                <td>{{ item.Stock }}</td>
                                <td>{{ item.CantidadSalida }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- <div class="table-responsive" v-show="this.ObjSolicitudAlmacen.IdSolicitudAlmacen!=0 && (this.ObjSolicitudAlmacen.Estatus=='Autorizada' || this.ObjSolicitudAlmacen.Estatus=='Finalizada')">
                    <h4>Salidas</h4>
                    <table class="table align-items-center mb-0">
                        <thead>
                            <tr>
                                <th>Nombre</th>
                                <th>Stock</th>
                                <th>¿Salió?</th>
                                <th>Salida</th>
                                <th>Observacion Salida</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,index) in ObjSolicitudAlmacen.Insumos" :key="index">
                                <td style="width:70%">{{ item.insumos.Nombre }}</td>
                                <td>{{ item.StockAnterior }}</td>
                                <td>{{item.SalidaCheck==0 ? 'No' : 'Si'}}</td>
                                <td>{{ item.CantidadSalida }}</td>
                                <td><textarea class="form-control" name="" id="" cols="30" rows="2" v-model="item.ComentarioSalida" disabled></textarea></td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="table-responsive" v-show="this.ObjSolicitudAlmacen.IdSolicitudAlmacen!=0 && this.ObjSolicitudAlmacen.Estatus=='Finalizada'">
                    <h4>Entradas</h4>
                    <table class="table align-items-center mb-0">
                        <thead>
                            <tr>
                                <th>Nombre</th>
                                <th>Entradas</th>
                                <th>Estatus Entrada</th>
                                <th>Observación Entrada</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,index) in ObjSolicitudAlmacen.Insumos" :key="index">
                                <td style="width:70%">{{ item.insumos.Nombre }}</td>
                                <td>{{ item.CantidadEntrada }}</td>
                                <td>{{ item.EstatusEntrada }}</td>
                                <td><textarea class="form-control" name="" id="" cols="30" rows="2" v-model="item.ComentarioEntrada" disabled></textarea></td>
                            </tr>
                        </tbody>
                    </table>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'Insumos',
    props:['pObjSolicitudAlmacen','pOrigen'],
    data() {
        return {
            ObjSolicitudAlmacen:{}
        }
    },
    methods: {
        AgregarInsumo(item)
        {
            let ObjLista={
                IdMaterial: item.IdMaterial,
                Nombre: item.Nombre,
                Stock: item.Stock,
                CantidadSalida: item.CantidadSalida,
                Disabled: item.Disabled,
                Check: item.Check
            }
            this.ObjSolicitudAlmacen.Insumos.push(ObjLista);
        },
        EliminarInsumo(Id)
        {
            let index = this.ObjSolicitudAlmacen.Insumos.findIndex((element)=>element.IdMaterial==Id);
            this.ObjSolicitudAlmacen.Insumos.splice(index,1);
        },
        AbrirModal(){
            this.bus.$emit('AbrirModalInsumo');
        }
    },
    created() {
        this.ObjSolicitudAlmacen = this.pObjSolicitudAlmacen;

        this.bus.$off('ArrayInsumos');
        this.bus.$on('ArrayInsumos',()=>{
            this.ObjSolicitudAlmacen = this.pObjSolicitudAlmacen;
        });

        this.bus.$off('AgregarInsumoModal');
        this.bus.$on('AgregarInsumoModal',(obj)=>{
            this.AgregarInsumo(obj);
        })
    },
}
</script>

<style>

</style>